import { useEffect, useState } from "react";
import { url } from "../utils/config";
import postData from "../custom_functions/postData";
import { toast } from "react-toastify";
import patchData from "../custom_functions/patchData";
import currency from "../utils/currency";
import { modalContainer } from "../utils/style";

function AddServiceBundle(props) {
    const [formData, setFormData] = useState({ currency: 'USD' });
    const [searchResults, setSearchResults] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [bundleList, setBundleList] = useState([]);
    const [isSearching, setIsSearching] = useState(false);

    useEffect(() => {
        if (props.bundleData) {
            const { name, cost, currency, service_lists } = props.bundleData;
            setFormData({ name, cost, currency: currency || 'USD' });
            setBundleList(service_lists);
        }
    }, []);

    async function search() {
        if (!searchKey.trim()) {
            toast.warning('Please enter a search term', { autoClose: 2000 });
            return;
        }
        setIsSearching(true);
        try {
            postData(`${url}/services/search`, { searchKey }, (error => {
                toast.error(error.response.data.message || error.message, { autoClose: 3000 });
                setIsSearching(false);
            }), (data) => {
                setSearchResults(data.data);
                setIsSearching(false);
            });
        } catch (error) {
            toast.error(error.response.data.message || error.message, { autoClose: 3000 });
            setIsSearching(false);
        }
    }

    async function updateBundleList(service) {

        const exists = bundleList.find(item => item.id === service.id);
        if (exists) {
            toast.warning('Service already added to bundle', { autoClose: 2000 });
            return;
        }
        setBundleList([...bundleList, service]);
        toast.success('Service added to bundle', { autoClose: 1500 });
    }

    function updateFormData(e) {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }

    function deleteService(ind) {
        const data = [...bundleList];
        data.splice(ind, 1);
        setBundleList(data);
    }

    async function updateServiceBundle() {
        if (
            formData.name && formData.name.length > 0 &&
            formData.cost && +formData.cost > 0 &&
            bundleList.length > 0
        ) {
            try {
                const bundleId = bundleList.map(bundle => bundle.id);
                patchData(`${url}/services/service_bundle/${props.bundleData.id}`, { ...formData, services: bundleId }, (error => {
                    toast.error(error.response.data.message || error.message, { autoClose: 3000 });
                    props.setBundleData();
                    props.setShowModal(false);
                }), (data) => {
                    toast.success(data.message, { autoClose: 3000 });
                    props.setBundleData();
                    props.setShowModal(false);
                    props.reload(1 + Math.random());
                });
            } catch (error) {
                toast.error(error.response.data.message || error.message, { autoClose: 3000 });
                props.setBundleData();
                props.setShowModal(false);
            }
        } else {
            toast.error('Please fill all the required fields!', { autoClose: 3000 });
        }
    }

    async function addServiceBundle() {
        if (
            formData.name && formData.name.length > 0 &&
            formData.cost && +formData.cost > 0 &&
            bundleList.length > 0
        ) {
            try {
                const bundleId = bundleList.map(bundle => bundle.id);
                postData(`${url}/services/service_bundle`, { ...formData, services: bundleId }, (error => {
                    toast.error(error.response.data.message || error.message, { autoClose: 3000 });
                    props.setShowModal(false);
                }), (data) => {
                    toast.success(data.message, { autoClose: 3000 });
                    props.setShowModal(false);
                    props.reload(1 + Math.random());
                });
            } catch (error) {
                toast.error(error.response.data.message || error.message, { autoClose: 3000 });
                props.setShowModal(false);
            }
        } else {
            toast.error('Please fill all the required fields!', { autoClose: 3000 });
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            search();
        }
    };

    return (
        <div className={modalContainer}>
            <div className="bg-white rounded-2xl shadow-2xl w-[90%] max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
                {/* Header */}
                <div className="bg-customOne px-8 py-4 flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <div className="bg-white/20 p-3 rounded-xl">
                            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                            </svg>
                        </div>
                        <div>
                            <h2 className="text-2xl font-bold text-white">
                                {props.bundleData ? 'Edit Service Bundle' : 'Create Service Bundle'}
                            </h2>
                        </div>
                    </div>
                    <button
                        onClick={() => { props.setShowModal(false); props.setBundleData && props.setBundleData(); }}
                        className="text-white/80 hover:text-white hover:bg-white/20 p-2 rounded-lg transition-all duration-200"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-8">
                    <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
                        {/* Left Panel - Search Services */}
                        <div className="lg:col-span-2 bg-gray-50 rounded-xl p-6 border border-gray-100">
                            <div className="flex items-center gap-2 mb-6">
                                <svg className="w-5 h-5 text-customOne" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                                <h3 className="text-lg font-semibold text-gray-800">Search Services</h3>
                            </div>

                            {/* Search Input */}
                            <div className="relative mb-4">
                                <input
                                    type="text"
                                    placeholder="Type service name..."
                                    className="w-full pl-4 pr-12 py-3 bg-white border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-customOne/20 focus:border-customOne transition-all"
                                    value={searchKey}
                                    onChange={e => setSearchKey(e.target.value)}
                                />
                                <button
                                    onClick={search}
                                    disabled={isSearching}
                                    className="absolute right-2 top-1/2 -translate-y-1/2 bg-customOne hover:bg-blue-700 text-white p-2 rounded-lg transition-all duration-200 disabled:opacity-50"
                                >
                                    {isSearching ? (
                                        <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    ) : (
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                        </svg>
                                    )}
                                </button>
                            </div>

                            {/* Search Results */}
                            <div className="space-y-3 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
                                {searchResults.length === 0 ? (
                                    <div className="text-center py-12">
                                        <svg className="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        <p className="text-gray-400 text-sm">Search for services to add to your bundle</p>
                                    </div>
                                ) : (
                                    searchResults.map((res, ind) => (
                                        <div
                                            key={ind}
                                            className="bg-white rounded-xl p-4 border border-gray-100 hover:border-customOne/30 hover:shadow-md transition-all duration-200 group"
                                        >
                                            <div className="flex justify-between items-start mb-3">
                                                <h4 className="font-semibold text-gray-800 text-sm group-hover:text-customOne transition-colors">{res.name}</h4>
                                                <span className="px-2 py-1 bg-blue-50 text-customOne text-xs font-medium rounded-full">{res.serviceType}</span>
                                            </div>
                                            <p className="text-gray-500 text-xs mb-3 line-clamp-2">{res.longDescription}</p>
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-1 text-green-600 font-semibold text-sm">
                                                    {res.estimatedCost ? (
                                                        <>
                                                            <span>$</span>
                                                            <span>{res.estimatedCost}</span>
                                                        </>
                                                    ) : (
                                                        <span>{res.estimatedTime} mins</span>
                                                    )}
                                                </div>
                                                <button
                                                    onClick={() => updateBundleList(res)}
                                                    className="flex items-center gap-1 bg-customOne/10 hover:bg-customOne text-customOne hover:text-white px-3 py-1.5 rounded-lg text-xs font-medium transition-all duration-200"
                                                >
                                                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                                    </svg>
                                                    Add
                                                </button>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>

                        {/* Right Panel - Bundle Details */}
                        <div className="lg:col-span-3 space-y-6">
                            {/* Bundle Info Card */}
                            <div className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm">
                                <div className="flex items-center gap-2 mb-6">
                                    <svg className="w-5 h-5 text-customOne" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <h3 className="text-lg font-semibold text-gray-800">Bundle Information</h3>
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Bundle Name <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-customOne/20 focus:border-customOne focus:bg-white transition-all"
                                            placeholder="Enter bundle name"
                                            value={formData.name || ''}
                                            name="name"
                                            onChange={updateFormData}
                                        />
                                    </div>

                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Bundle Cost <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-medium">$</span>
                                                <input
                                                    type="number"
                                                    className="w-full pl-8 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-customOne/20 focus:border-customOne focus:bg-white transition-all"
                                                    placeholder="0.00"
                                                    value={formData.cost || ''}
                                                    name="cost"
                                                    onChange={updateFormData}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Currency</label>
                                            <select
                                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-customOne/20 focus:border-customOne focus:bg-white transition-all appearance-none cursor-pointer"
                                                value={formData.currency || ''}
                                                name="currency"
                                                onChange={updateFormData}
                                            >
                                                {currency.map((cur, ind) => (
                                                    <option key={ind} value={cur}>{cur}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Selected Services */}
                            <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
                                <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
                                    <div className="flex items-center gap-2">
                                        <svg className="w-5 h-5 text-customOne" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                        </svg>
                                        <h3 className="text-lg font-semibold text-gray-800">Selected Services</h3>
                                    </div>
                                    <span className="bg-customOne/10 text-customOne px-3 py-1 rounded-full text-sm font-medium">
                                        {bundleList.length} service{bundleList.length !== 1 ? 's' : ''}
                                    </span>
                                </div>

                                <div className="max-h-[280px] overflow-y-auto">
                                    {bundleList.length === 0 ? (
                                        <div className="text-center py-12">
                                            <svg className="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                                            </svg>
                                            <p className="text-gray-400 text-sm">No services added yet</p>
                                            <p className="text-gray-300 text-xs mt-1">Search and add services from the left panel</p>
                                        </div>
                                    ) : (
                                        <table className="w-full">
                                            <thead className="bg-gray-50 sticky top-0">
                                                <tr>
                                                    <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Service</th>
                                                    <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Type</th>
                                                    <th className="text-right px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Cost/Time</th>
                                                    <th className="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider w-16"></th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-100">
                                                {bundleList.map((bundle, ind) => (
                                                    <tr key={ind} className="hover:bg-gray-50 transition-colors group">
                                                        <td className="px-6 py-4">
                                                            <div className="flex items-center gap-3">
                                                                <div className="w-8 h-8 rounded-lg bg-customOne/10 flex items-center justify-center text-customOne font-semibold text-xs">
                                                                    {(bundle.name || '').charAt(0).toUpperCase()}
                                                                </div>
                                                                <div>
                                                                    <p className="font-medium text-gray-800 text-sm">{bundle.name}</p>
                                                                    <p className="text-gray-400 text-xs">ID: {bundle.id}</p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <span className="px-2.5 py-1 bg-blue-50 text-blue-600 text-xs font-medium rounded-lg">{bundle.serviceType}</span>
                                                        </td>
                                                        <td className="px-6 py-4 text-right">
                                                            <span className="font-semibold text-gray-800 text-sm">{bundle.estimatedTime ? bundle.estimatedTime + " mins" : "$" + bundle.estimatedCost}</span>
                                                        </td>
                                                        <td className="px-6 py-4 text-center">
                                                            <button
                                                                onClick={() => deleteService(ind)}
                                                                className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all opacity-0 group-hover:opacity-100"
                                                            >
                                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                </svg>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="px-8 py-5 bg-gray-50 border-t border-gray-100 flex items-center justify-between">
                    <div className="flex items-center gap-2 text-gray-500 text-sm">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span>All fields marked with <span className="text-red-500">*</span> are required</span>
                    </div>
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => { props.setShowModal(false); props.setBundleData && props.setBundleData(); }}
                            className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-xl font-medium text-sm hover:bg-gray-100 transition-all duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => { if (props.bundleData) { updateServiceBundle() } else { addServiceBundle() } }}
                            className="px-6 py-2.5 bg-customOne hover:bg-blue-700 text-white rounded-xl font-medium text-sm transition-all duration-200 flex items-center gap-2 shadow-lg shadow-customOne/25"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            {props.bundleData ? 'Update Bundle' : 'Create Bundle'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddServiceBundle;